import type { Tables } from "@msuite/utils/types";
import { usePartnership } from "@/hooks/use-partnership";
import { OrganizationAvatar } from "../organization-card";

/** Props Interface */
interface TicketAssigneePartnershipProps {
	ticket: Tables<"tickets">;
}

export function TicketAssigneePartnership({ ticket }: TicketAssigneePartnershipProps) {
	/** Hooks */
	const { partnership } = usePartnership(ticket.assigneePartnership);

	if (!partnership) return null;

	/** Render */
	return (
		<OrganizationAvatar
			orgId={partnership.partnerOrgId}
			withTooltip
		/>
	);
}
